import {
  ATTACHMENTS_UPDATE,
  AUTHORIZATION_SUCCESS,
  IS_JANUS_CALL,
  IS_NODE_DISCONNECTED,
  LOGGED_DATA_UPDATE,
  MESSAGES_UPDATE,
  REVIEW_ISSUES,
  CALL_ID, UPDATE_UNREAD_MESSAGE,
  JITSI_JOINED,
  CHAT_MESSAGES_UPDATE,
  UPDATE_UNREAD_PRIVATE_CHATS,
  SET_SELECTED_CHAT,
  UPDATE_UNREAD_GROUP_CHAT
} from "./Types";
import { Attachment, ChatThread, LoggedData, Message, Participant, Room } from "../types";

export interface REDUCER_TYPE {
    jwtToken: String;
    socketId: String;
    room: Room|null,
    authUser: Participant|null,
    remoteUser: Participant|null,
    messages: Message[]|null,
    isGrouped?: 0 | 1;
    chatMessages?: Record<string, Message[]>;
    chatThreads: ChatThread[]
    participants?: Participant[];
    unreadPrivateChats?: Record<string, number>;
    selectedChat?: string;
    unreadGroupChat?: number;
    attachments: Attachment[]|null,
    loggedData: LoggedData|any,
    isJanusCall: boolean,
    reviewIssues: { audio: string[], video: string[] } | null,
    callId: number,
    unreadMessage: number,
    jitsiJoined: boolean
}

const initialState = {
    jwtToken: '',
    socketId: '',
    room: null,
    authUser: null,
    remoteUser: null,
    messages: null,
    isGrouped: 0,
    chatMessages: {},
  chatThreads: [],
    participants: [],
    unreadPrivateChats: {},
    selectedChat: 'group',
    unreadGroupChat: 0,
    attachments: null,
    loggedData: null,
    isJanusCall: false,
    isNodeDisconnected: false,
    reviewIssues: null,
    callId: 0,
    jitsiMeeting: null,
    unreadMessage: 0,
    jitsiJoined: false,

}

export default (state = initialState, action: any) => {
    console.log('---' + action.type + '---', action.payload)
    switch (action.type) {
        case AUTHORIZATION_SUCCESS:
            return {
                ...state,
                jwtToken: action.payload.token,
                socketId: action.payload.socketId,
                room: action.payload.room,
                authUser: action.payload.authUser,
                remoteUser: action.payload.remoteUser,
                messages: action.payload.messages,
                isGrouped: action.payload.isGrouped,
                chatMessages: action.payload.chatMessages,
                chatThreads: action.payload.chatThreads,
                participants: action.payload.participants,
                attachments: action.payload.attachments,
                jitsiMeeting: action.payload.jitsiMeeting,
            }
        case LOGGED_DATA_UPDATE:
            return {
                ...state,
                loggedData: action.payload
            }
        case IS_JANUS_CALL:
            return  {
                ...state,
                isJanusCall: action.payload
            }
        case IS_NODE_DISCONNECTED:
            return {
                ...state,
                isNodeDisconnected: action.payload
            }
        case MESSAGES_UPDATE:
            return  {
                ...state,
                messages: action.payload
            }
        case ATTACHMENTS_UPDATE:
            return  {
                ...state,
                attachments: action.payload
            }
        case CHAT_MESSAGES_UPDATE:
            return {
                ...state,
                chatMessages: action.payload
            }
        case UPDATE_UNREAD_PRIVATE_CHATS:
            return {
                ...state,
                unreadPrivateChats: action.payload
            }
        case SET_SELECTED_CHAT:
            return {
                ...state,
                selectedChat: action.payload
            }
        case UPDATE_UNREAD_GROUP_CHAT:
            return {
                ...state,
                unreadGroupChat: action.payload
            }
        case REVIEW_ISSUES:
            return  {
                ...state,
                reviewIssues: action.payload
            }
        case CALL_ID:
            return {
                ...state,
                callId: action.payload
            }
        case UPDATE_UNREAD_MESSAGE:
          return {
            ...state,
            unreadMessage: action.payload
          }
        case JITSI_JOINED:
            return {
                ...state,
                jitsiJoined: action.payload
            }
        default:
            return state
    }
}
